import { IconButton, useTheme } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";

import Context from "../../../context";

// ----------------------------------------------------------------------

export const BackBtn = () => {
	const { values } = useContext(Context);
	const { contentBackgroundColor, primaryTextColor } = values;
	const theme = useTheme();

	return (
		<IconButton
			sx={{
				backgroundColor: contentBackgroundColor,
				boxShadow: theme.palette.background.paper === contentBackgroundColor ? 1 : 0,
				position: "absolute",
				p: 0.8
			}}
		>
			<Iconify icon='tdesign:arrow-left' width={16} color={primaryTextColor} />
		</IconButton>
	);
};

export default BackBtn;
